import { Card, CardBody, Col, Row } from "reactstrap";

interface InvoiceSummaryProps {
  totals: {
    subtotal: number;
    totalDiscount: number;
    subtotalAfterDiscount: number;
    totalGst: number;
    grandTotal: number;
  };
  t: (key: string) => string;
}

export const InvoiceSummary: React.FC<InvoiceSummaryProps> = ({ totals, t }) => (
  <Card className="mt-3 bg-light text-dark">
    <CardBody>
      <h6>{t("Invoice Summary")}</h6>
      <Row className="align-items-start mt-3">
        <Col md={12} className="text-end">
          {[
            { label: t("Subtotal"), value: totals.subtotal },
            { label: t("Total Discount"), value: totals.totalDiscount },
            { label: t("Subtotal - Discount"), value: totals.subtotalAfterDiscount },
            { label: t("Total GST"), value: totals.totalGst },
            { label: t("Grand Total"), value: totals.grandTotal },
          ].map(({ label, value }) => (
            <p key={label}>
              <strong>{label}:</strong> ${value.toFixed(2)}
            </p>
          ))}
        </Col>
      </Row>
    </CardBody>
  </Card>
);